import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToOwnerIntakeSubmission,
  type OwnerIntakeSubmission,
  type OwnerIntakeSubmissionApiResource,
} from '@/api/intake/intakeApi.types';
import {
  mapApiResourceToPreVisitPhoto,
  mapApiResourceToPreVisitQuestions,
  mapPreVisitQuestionDrafts,
  type PreVisitPhoto,
  type PreVisitPhotoApiResource,
  type PreVisitQuestion,
  type PreVisitQuestionDraft,
  type PreVisitQuestionsApiResource,
} from './preVisitApi.types';

export async function fetchWorkspacePreVisitQuestions(): Promise<PreVisitQuestion[]> {
  const response = await httpClient.get<PreVisitQuestionsApiResource>(
    '/me/workspace/pre-visit-questions'
  );
  return mapApiResourceToPreVisitQuestions(response.data);
}

export async function replaceWorkspacePreVisitQuestions(
  questions: PreVisitQuestionDraft[]
): Promise<PreVisitQuestion[]> {
  const response = await httpClient.put<PreVisitQuestionsApiResource>(
    '/me/workspace/pre-visit-questions',
    mapPreVisitQuestionDrafts(questions)
  );
  return mapApiResourceToPreVisitQuestions(response.data);
}

export async function fetchOwnPreVisitQuestions(): Promise<PreVisitQuestion[]> {
  const response = await httpClient.get<PreVisitQuestionsApiResource>(
    '/me/intake/pre-visit-questions'
  );
  return mapApiResourceToPreVisitQuestions(response.data);
}

export async function uploadOwnPreVisitPhoto(
  submissionId: string,
  questionCode: string,
  file: File
): Promise<PreVisitPhoto> {
  const formData = new FormData();
  formData.append('question_code', questionCode);
  formData.append('file', file);
  const response = await httpClient.post<PreVisitPhotoApiResource>(
    '/me/intake/' + submissionId + '/pre-visit-photos',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return mapApiResourceToPreVisitPhoto(response.data);
}

export async function removeOwnPreVisitPhoto(
  submissionId: string,
  photoId: string
): Promise<OwnerIntakeSubmission> {
  const response = await httpClient.delete<OwnerIntakeSubmissionApiResource>(
    '/me/intake/' + submissionId + '/pre-visit-photos/' + photoId
  );
  return mapApiResourceToOwnerIntakeSubmission(response.data);
}
